import {
    ChangeDetectionStrategy,
    Component, computed, inject, input
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { ICardWithIIconBlok } from './card-with-icon.model';
import { CmsComponent } from '@seven1/angular-storyblok-cms';

@Component({
    selector: 'app-card-with-icon',
    imports: [MatIconModule, NgClass, CmsComponent],
    templateUrl: './card-with-icon.component.html',
    styleUrl: './card-with-icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class]': `getOuterClasses()`,
    },
})
export class CardWithIconComponent {
    private _tailwind = inject(TailwindService);
    block = input.required<ICardWithIIconBlok>();

    getTextClasses = computed<string[]>(() => {
        return this._tailwind.getTypographyClasses(this.block())
    });

    getOuterClasses = computed<string[]>(() => {
       const block = this.block();
       return [
           'block',
           ...this._tailwind.getSpacingClasses(block),
           ...this._tailwind.getSpacingClasses({
               marginX: block.align,
               marginXTablet: block.alignTablet,
               marginXDesktop: block.alignDesktop,
           }),
           ...this._tailwind.getBorderRadiusClasses(block),
           ...this._tailwind.getDisplayClasses(block),
           ...this._tailwind.getBackgroundShadeClasses(block),
       ];
    });
}
